module.exports = __webpack_public_path__ + "img/diapositiva-4-3.90ed1f5d.png";